import React, { useState, useEffect } from "react";
import styles from "./QuestionPage.module.css";
import logo from "./images/unisologo.png"; // put your logo in this path
import {
  isTokenExpired,
  removeToken,
  getToken,
  decodeToken,
} from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import axios from "axios";


import { useLocation,useParams } from "react-router-dom";
import { use } from "react";
import Header from "./header";
import MyFooter from "./my footer";



const QuestionPreview = () => {
      const [scheduleDate,setscheduleDate]=useState({});

    const location=useLocation();
    
    const params=useParams();
    console.log('params:',params);
    console.log('location path:',location.pathname)
    //const {state}=location;
    const {class_id,semester_id,course_id,exam_type}=useParams()
      console.log(
    'class:', class_id,
    'sem:', semester_id,
    'course:', course_id,
    'exam type:', exam_type
  );

    const [questions,setQuestions]=useState([]);

useEffect(() => {
  const getData = async () => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-get-schedule`;
      const body = { id: 1 };
      const response = await postData(url, body);

      const courseData = response.data[0];
      console.log("schedule date from response:", courseData);

      setscheduleDate(courseData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getQuestion=async()=>{

    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-question`;
      const body = { 
       class_id:class_id,
       semester_id:semester_id,
       course_id:course_id,
       exam_type:exam_type

      };
      const response = await postData(url, body);

      const q = response.data;
      setQuestions(q)
      

     
    } catch (error) {
      console.error("Error fetching data:", error);
    }


  }

  if (class_id) {
    getData();
    getQuestion()
  }
}, []); // ✅ Only run when `id` changes

useEffect(()=>{
console.log('question:',questions);
},[questions])


   
console.log('class:',class_id,'sem:',semester_id,'course:',course_id,'exam type:',exam_type)
  const [timeLeft, setTimeLeft] = useState(60 * 60); // 1 hour




const handleSubmit = async () => {
  try {
    const token = getToken(); 
    const insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/web_answer`;

    const currentDate = new Date().toISOString().split("T")[0];

    // Prepare each answer row
    const answerRows = Object.values(answers).map((ans) => ({
     // student_id: student_id,
      question_id: ans.question_id,
      marks: ans.marks,
      answer: ans.answer,
      //user_id: student_id,
      date: currentDate, // ✅ MySQL DATE format
    }));

    console.log("📤 Submitting answers (row-by-row):", answerRows);

    // Send each answer individually
    for (const row of answerRows) {
      const response = await axios.post(insertUrl, row, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      });

      // Check each response for success
      console.log('message:',response.data);

     
    }
    alert('Summited Success')
    
  
  } catch (error) {
    console.error("❌ Submission error:", error);
    alert("Failed to submit answers. Please try again.");
 
  }
};

 

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}h ${mins}m ${secs}s`;
  };

  // 🧩 Question List
 

  const [answers, setAnswers] = useState({});

const handleAnswer = (index, value, question_id) => {
  setAnswers((prev) => {
    // find the current question using id~hide
    const question = questions.find((q) => q["id~hide"] === question_id);

    let marks = 0;
    if (question) {
      if (question.type === "tf" || question.type === "choose") {
        // check if selected answer is correct
        if (
          value.trim().toLowerCase() ===
          question.correct_answer?.trim().toLowerCase()
        ) {
          marks = question.marks || 0;
        } else {
          marks = 0;
        }
      } else if (question.type === "direct") {
        marks = 0; // direct question default
      }
    }

    return {
      ...prev,
      [question_id]: {
        answer: value,
        marks: marks,
        question_id: question_id,
        type: question?.type || null,
      },
    };
  });
};


  useEffect(()=>{
    console.log('answers:',answers);
  },[answers])

  return (
    <>

    
    <div className={styles.container}>
      {/* ===== Header ===== */}
     
      {/* ===== Questions ===== */}
      <div className={styles.questions}>
        { 
         questions.length>0 &&
        
        questions.map((q, index) => (
          <div key={index} className={styles.questionCard}>
            <h3 className={styles.qText}>
              {index + 1}. {q.name} <span className={styles.marks}>({q.marks} marks)</span>
            </h3>

            {q.type === "tf" && (
              <div className={styles.optionGroup}>
                {["True", "False"].map((opt) => (
                  <label
                    key={opt}
                    className={`${styles.option} ${answers[index] === opt ? styles.selected : ""}`}
                  >
                    <input type="radio" name={`q${index}`} value={opt} onChange={() => handleAnswer(index, opt,q["id~hide"])} />
                    {opt}
                  </label>
                ))}
              </div>
            )}

            {q.type === "choose" && (
              <div className={styles.optionGroup}>
                {q.options.split(",").map((opt, i) => (
                  <label
                    key={i}
                    className={`${styles.option} ${answers[index] === opt ? styles.selected : ""}`}
                  >
                    <input type="radio" name={`q${index}`} value={opt} onChange={() => handleAnswer(index, opt,q["id~hide"])} />
                    {opt}
                  </label>
                ))}
              </div>
            )}

            {q.type === "direct" && (
              <textarea
                className={styles.directInput}
                placeholder="Write your answer here..."
                onChange={(e) => handleAnswer(index, e.target.value,q["id~hide"])}
              ></textarea>
            )}
          </div>
        ))}
      </div>

      {/* <button className={styles.submitBtn} onClick={handleSubmit}>Submit Answers</button> */}
    </div>
  
    </>
  );
};

export default QuestionPreview;
